import type { Route } from 'vue-router'

/**
 * The page the /v3 iframe is asked to show for a v2 route: the route's `meta.v3Route` plus the
 * query string the v2 URL carried. Without the query a deep link such as
 * `/radar?viewReport=878&selectedFilter=13` (a preset-match push, BGT-8061) or
 * `/radar?scrollToReport=…` (a chat push, BGT-7392) lands on the bare page.
 */
export function v3PageFor(route: Pick<Route, 'matched' | 'fullPath'>): string | null {
	const record = route.matched.find((r) => r.meta && r.meta.v3Route)
	if (!record) return null

	const page = String(record.meta.v3Route)
	const queryStart = route.fullPath.indexOf('?')
	if (queryStart === -1) return page

	const query = route.fullPath.slice(queryStart).replace(/#.*$/, '')
	return query.length > 1 ? page + query : page
}

/**
 * The path part of a page value: the key the last-visited URL is remembered under, whatever
 * query a deep link added.
 */
export function v3PagePath(page: string): string {
	const queryStart = page.indexOf('?')
	return queryStart === -1 ? page : page.slice(0, queryStart)
}

/**
 * A page with a query is a deep link and must be shown as is, not replaced by the URL the user
 * last visited under that page.
 */
export function isV3DeepLink(page: string): boolean {
	return page.indexOf('?') !== -1
}
